import { ChangeEvent, useCallback, useEffect,useState } from "react";


import useUiuxStore from "src/store/useUiuxStore";
import { defaultPUR1020_R01Filter, usePUR1020_R01Store } from "./Store_PUR1020_R01";

import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionDoubleForm } from "src/components/common/form/search/SearchSectionDoubleForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import {  SearchSpacer } from "src/components/common/common";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { searchCustomer } from "src/apis/customerApi";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";

export const SearchSection_PUR1020_R01 = () => {
	const { PUR1020_R01Filter, setPUR1020_R01Filter } = usePUR1020_R01Store();

    const { setCodeSearchModalProps } = useUiuxStore();
    
	const { compCdList, } = useCommonCodeStore();

    const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });



	const itemInfoHandleFoucsId = 'infoItemInput_search';
	const custInfoHandleFoucsId = 'infoCustInput_search';
	
	// Info 폼 코드 검색 필드 설정
	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'customCd',
			category: '거래처',
			focusId: custInfoHandleFoucsId,
			responseMapping: {
				customCd: 'customCd',
				customNm: 'customNm',
			},
			searchFunction: async (searchText: string) => {
				const customerResponse = await searchCustomer(searchText);
				return customerResponse.data.data.find(value => value.customCd === searchText);
			},
			extraFilter: () => ({
				customCd: PUR1020_R01Filter.customCd || '',
				customNm: PUR1020_R01Filter.customNm || '',
			}),
		},		
		{
			fieldName: 'itemCd',
			category: '품목코드',
			focusId: itemInfoHandleFoucsId,
			responseMapping: {
				itemCd: 'itemCd',
				itemNm: 'itemNm',
			},
			extraFilter: () => ({
				itemCd: PUR1020_R01Filter.itemCd || '',
				itemNm: PUR1020_R01Filter.itemNm || '',
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: PUR1020_R01Filter,
		setEditData: setPUR1020_R01Filter,
		defaultData: defaultPUR1020_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'PUR1020_R01_search'
	});



    return (
		<>
		<SearchSectionDoubleForm >
			{/* 회사 선택 */}
			<SearchDropDownForm
				label="사업장"
                value={PUR1020_R01Filter.compCd}
				optionList={compCdList}
				onChangeValue={(value) => setPUR1020_R01Filter({ compCd: value })}
			/>
			<SearchDateRangeForm
				label="수주기간"
				wrapperOption={{
					titleStyle: 'h-[24px] flex items-center truncate shrink-0 w-[50px] min-w-[50px]',
				}}
				visible={pickerVisible}						setVisible={setPickerVisible}
                dateRange={PUR1020_R01Filter.dateRange}		setDateRange={(dateRange) => setPUR1020_R01Filter({ dateRange: dateRange })}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
			/>
			<SearchCodeModalForm
				label="거래처"
                value={PUR1020_R01Filter.customCd}
				valueLabel={PUR1020_R01Filter.customNm}
				onChange={getFieldHandlers('customCd').onChange}
				onDoubleClick={getFieldHandlers('customCd').onDoubleClick}
				onKeyDown={getFieldHandlers('customCd').onEnterKeyDown}
			/>
			<SearchCodeModalForm
				label="품목코드"
				value={PUR1020_R01Filter.itemCd}
				valueLabel={PUR1020_R01Filter.itemNm}
				onChange={getFieldHandlers('itemCd').onChange}
				onDoubleClick={getFieldHandlers('itemCd').onDoubleClick}
				onKeyDown={getFieldHandlers('itemCd').onEnterKeyDown}
			/>
			
		</SearchSectionDoubleForm>
		{/* searchedCustomer : {JSON.stringify(searchedCustomer)} */}
		</>
	)
}

export default SearchSection_PUR1020_R01;
